import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface DailyPoint {
  date: string;   // YYYY-MM-DD
  newUsers: number;
  newPosts: number;
}

/// 7일 신규 유저·게시물 라인 차트.
const DailyTrendsChart: React.FC<{ data: DailyPoint[] }> = ({ data }) => {
  // x축 라벨을 M/D 로 축약
  const formatted = data.map((d) => ({
    ...d,
    label: d.date.slice(5).replace('-', '/'),
  }));

  return (
    <Card sx={{ flex: '2 1 500px', minWidth: 0 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          일별 신규 지표 (최근 7일)
        </Typography>
        <Box sx={{ width: '100%', height: 260 }}>
          <ResponsiveContainer>
            <LineChart data={formatted} margin={{ top: 8, right: 16, bottom: 8, left: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
              <XAxis dataKey="label" fontSize={12} />
              <YAxis fontSize={12} allowDecimals={false} />
              <Tooltip />
              <Legend />
              <Line
                type="monotone"
                dataKey="newUsers"
                name="신규 유저"
                stroke="#1976d2"
                strokeWidth={2}
                dot={{ r: 3 }}
                activeDot={{ r: 6 }}
              />
              <Line
                type="monotone"
                dataKey="newPosts"
                name="신규 게시물"
                stroke="#2e7d32"
                strokeWidth={2}
                dot={{ r: 3 }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DailyTrendsChart;
